export default class StormService {

    constructor(resource) {
        this._resource = resource('block/sobre');
    }

    blocks() {
        return this._resource
            .query()
            .then( res =>  {
                return res.json();
            }, err => {
                throw new Error('Não foi possível obter a lista de publicacoes.');
            });
    }
}



// WEBPACK FOOTER //
// ./src/domain/StormService.js